<template>
  <v-app>
    <div class="container">
      <div class="row text-start">
        <div class="col-12 text-center">
          <h1 class="mt-4 title-text">リアルタイムくじ引きとは</h1>
        </div>
        <div class="col-12 text-center sub-text">
          <p>ライブ配信で応援がリアルタイムで届く、<br />新感覚のくじ引きサービスです。</p>
        </div>
        <div class="col-12 text-center hero-image-container">
          <img
            src="/img/aboutkujibikihero.webp"
            alt="リアルタイムくじ引きの紹介画像"
            class="hero-image"
          />
        </div>
        <div class="col-12">
          <div class="thin-divider"></div>
        </div>
      </div>
      <div class="row">
        <div class="heading-button margin-bottom-35">
          <h3 class="heading-button__text">サービスのポイント</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 point-items-container">
          <div class="point-item">
            <img src="/img/aboutkujibikipoint1.webp" alt="ポイント1" class="point-image" />
            <p>ライブ配信中のくじ引きで応援が<br />リアルタイムで届きます！</p>
          </div>
          <div class="point-item">
            <img src="/img/aboutkujibikipoint2.webp" alt="ポイント2" class="point-image" />
            <p>ハズレなしで絶対当たります！</p>
          </div>
          <div class="point-item">
            <img src="/img/aboutkujibikipoint3.webp" alt="ポイント3" class="point-image" />
            <p>限定のオリジナルグッズです！</p>
          </div>
        </div>
      </div>
      <div class="row heading-button-container">
        <div class="heading-button">
          <h3 class="heading-button__text">視聴＆購入方法</h3>
        </div>
      </div>
      <div class="forhaikei">
        <div class="row background-pink">
          <div class="col-12 ui-image-container">
            <div class="step-text">STEP1 イベントを選択<br /><br /></div>
            <img src="/img/aboutkujibikiui1.webp" alt="視聴＆購入方法" class="ui-image" />
          </div>
          <div class="col-12 ui-image-container">
            <div class="step-text">STEP2 くじボタンをタップ<br /><br /></div>
            <img src="/img/aboutkujibikiui2.webp" alt="視聴＆購入方法" class="ui-image" />
          </div>
          <div class="col-12 ui-image-container">
            <div class="step-text">STEP3 購入数を選択し住所、<br />支払い方法を選択</div>
            <img src="/img/aboutkujibikiui3.webp" alt="視聴＆購入方法" class="ui-image" />
          </div>
          <div class="col-12 ui-image-container step-col-2">
            <div class="step-text">STEP4 その場で当選結果確認<br /><br /></div>
            <img src="/img/aboutkujibikiui4.webp" alt="視聴＆購入方法" class="ui-image" />
          </div>
          <div class="col-12 ui-image-container step-col-3">
            <div class="step-text">STEP5 当選結果がコメントに<br />投稿され応援が届く</div>
            <img src="/img/aboutkujibikiui5.webp" alt="視聴＆購入方法" class="ui-image" />
          </div>
        </div>
      </div>
      <div class="row heading-button-container kinou-container">
        <div class="heading-button margin-bottom-35">
          <h3 class="heading-button__text">機能</h3>
        </div>
      </div>
      <div class="row function-item-wrapper">
        <div class="function-item">
          <p>購入時コメント機能</p>
          <p>購入時に自動で、ニックネームと購入コメント、当選結果が投稿されます。</p>
          <img
            src="/img/aboutkujibikiui5.webp"
            alt="視聴＆購入方法"
            class="ui-image function-image"
          />
          <button onclick="window.location.href='/'">イベント一覧を見る</button>
        </div>
        <div class="function-item function-item-title2">
          <p>マイコレクション</p>
          <p>
            購入したイベントごとの当せん結果を確認できるページです。当たってない商品もわかります。コンプリートを目指そう！
          </p>
          <img
            src="/img/aboutkujibikifunction2.webp"
            alt="視聴＆購入方法"
            class="ui-image function-image2"
          />
          <button onclick="window.location.href='/mycollection'">マイコレクションを見る</button>
        </div>
        <div class="function-item function-item-title3">
          <p>配信時間外購入</p>
          <p>
            イベント期間中でしたら、配信時間外でも購入が可能です。万が一配信を見逃しても安心です！
          </p>
          <img
            src="/img/aboutkujibikifunction3.webp"
            alt="視聴＆購入方法"
            class="ui-image function-image3"
          />
          <button onclick="window.location.href='/'">イベント一覧を見る</button>
        </div>
        <div class="function-item function-item-title4">
          <p>マイページ</p>
          <p>
            登録情報の確認・登録・修正が可能です。事前に登録しておくと、購入時に登録が不要で便利です。
          </p>
          <img
            src="/img/aboutkujibikifunction4.webp"
            alt="視聴＆購入方法"
            class="ui-image function-image4"
          />
          <button onclick="window.location.href='/myaccount'">マイページを見る</button>
        </div>
      </div>
      <div class="row faq-container">
        <div class="heading-button margin-bottom-15">
          <h3 class="heading-button__text">よくある質問</h3>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="faq-item">
          <p>配信時間外購入について</p>
          <p>
            配信時間外での購入は、イベント期間中であれば24時間可能です。<span class="pc-br"></span>
            配信を見逃しても、配信に参加できなくてもご購入できます。
          </p>
          <button onclick="window.location.href='/faq'">その他のよくある質問へ</button>
        </div>
      </div>
    </div>
  </v-app>
</template>

<style scoped>
.custom-content {
  line-height: 1.4; /* これにより行の高さが増加します */
}
.title-text {
  font-size: 24px;
  margin-top: 40px !important;
}
.sub-text {
  margin-left: 40px;
  margin-right: 40px;
  font-size: 14px;
  margin-top: 35px;
}
.hero-image {
  width: 100%;
  height: auto;
  margin-top: 30px;
}
.hero-image-container {
  margin-left: 40px;
  margin-right: 40px;
}
.thin-divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 50px;
  margin-bottom: 30px;
}
.heading-button-container {
  padding-top: 50px;
  background-color: #ffe3f2;
}
.kinou-container {
  background-color: #ffffff;
}
.heading-button {
  display: inline-block;
  margin-left: 40px;
  margin-right: 40px;
  padding: 10px 16px;
  border: 3px solid #982da6;
  border-radius: 8px;
  background-color: #ffe3f2;
  box-shadow: 5px 5px 0 #da3990;
  color: #982da6;
  min-width: 150px;
}
.heading-button__text {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
.margin-bottom-35 {
  margin-bottom: 35px;
  min-width: 150px;
}
.margin-bottom-15 {
  margin-bottom: 15px;
  min-width: 150px;
}
.point-items-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-left: 70px;
  margin-right: 70px;
  margin-bottom: 20px;
}
.point-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.point-image {
  max-width: 40%;
  height: auto;
  margin-top: 20px;
}
.point-item p {
  margin: 17px 0 0 0;
  font-size: 14px;
  text-align: center;
}

.ui-image-container {
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 40px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 30px;
}

.step-text {
  font-size: 14px;
  font-weight: 600;
  color: #da3990;
  text-align: center;
  margin-bottom: 16px;
  line-height: 1.2;
}

.ui-image {
  width: 100%;
  height: auto;
}

.function-image {
  width: 65%;
  margin-bottom: 15px;
}

.function-image2 {
  scale: 1.1;
  margin-bottom: 80px;
}

.function-image3 {
  width: 40%;
  margin-bottom: 70px;
}

.function-image4 {
  scale: 1;
  margin-bottom: 80px;
}

.background-pink {
  background-color: #ffe3f2;
  padding-top: 20px;
  padding-bottom: 60px;
}
.ui-image-step3 {
  padding-top: 20px;
  padding-bottom: 20px;
  scale: 1.15;
  display: block;
  margin: 0 auto;
}

.ui-image-step4 {
  padding-top: 20px;
  padding-bottom: 20px;
  scale: 1.15;
  display: block;
  margin: 0 auto;
}

.ui-image-step5 {
  margin-top: -60px;
  margin-bottom: -50px;
  scale: 0.7;
  display: block;
}
.function-item {
  margin: 40px;
  padding: 30px;
  padding-top: 40px;
  border: 3px solid #982da6;
  box-shadow: inset 0 0 0 3px #da3990;
  border-radius: 12px;
  background-color: #ffffff;
  background-clip: content-box;
  height: 450px;
  margin-top: 50px;
  position: relative;
}
.function-item p:first-child {
  font-size: 18px;
  font-weight: 600;
  color: #982da6;
  margin: 0 0 25px 0;
}
.function-item p:nth-child(2) {
  font-size: 14px;
  color: #333;
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.function-item-title2 p:nth-child(2) {
  margin-bottom: 50px;
}

.function-item-title3 p:nth-child(2) {
  margin-bottom: 50px;
}

.function-item-title4 p:nth-child(2) {
  margin-bottom: 70px;
}

.function-item button {
  background-color: #da3990;
  color: white;
  border: none;
  padding: 15px 10px 15px 10px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
}
/* .function-item button:hover {
  transform: translate(-50%, -2px);
  box-shadow: 5px 5px 0 #da3990;
} */

.faq-item {
  margin: 40px;
  padding: 30px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
}
.faq-item p:first-child {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
}
.faq-item p:nth-child(2) {
  font-size: 14px;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.6;
}
.faq-item button {
  background-color: #da3990;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
/* .faq-item button:hover {
  transform: translate(-2px, -2px);
  box-shadow: 5px 5px 0 #da3990;
} */
.faq-container {
  margin-top: 60px;
}

@media (min-width: 750px) {
  .hero-image {
    width: 400px;
  }
  .hero-image-container {
    padding-left: 27vh;
    padding-right: 27vh;
  }
  .point-image {
    margin-top: 0px;
    max-width: 120px;
  }
  .point-items-container {
    flex-direction: row;
    gap: 40px;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
  }
  .point-item {
    flex: 0 0 100px;
    width: 400px;
  }
  .background-pink {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-left: 27vh;
    padding-right: 27vh;
    max-width: calc(230px * 3 + 8px * 6 + 27vh * 2);
    margin-left: auto;
    margin-right: auto;
  }
  /* .ui-image-container {
    margin-left: 0;
    margin-right: 0;
  } */
  .ui-image-container {
    margin: 8px;
    margin-top: 20px;
  }
  .background-pink .ui-image-container {
    flex: 0 0 230px;
    max-width: 230px;
    width: 230px;
  }
  .ui-image-step3 {
    scale: 1;
    padding-top: 0;
    padding-bottom: 0;
  }
  .ui-image-step4 {
    scale: 1;
    padding-top: 0;
    padding-bottom: 0;
  }
  .ui-image-step5 {
    margin-top: 0;
    margin-bottom: 0;
    scale: 1;
  }
  .sub-text {
    font-size: 16px;
  }
  .function-image {
    width: 180px;
  }
  .function-image2 {
    width: 250px;
  }
  .function-item-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 315px);
    gap: 20px;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
  .function-item {
    margin: 0;
    width: 315px;
  }

  .heading-button-container {
    padding-bottom: 40px;
  }

  .margin-bottom-35 {
    margin-bottom: 70px;
  }

  .faq-item {
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
  }
  .forhaikei {
    background-color: #ffe3f2;
  }
  .pc-br {
    display: block;
  }
  .heading-button {
    padding: 15px 20px;
  }
  .heading-button__text {
    font-size: 20px;
  }
}
</style>
